import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { tenant } from '../../model/common/common.model';
import { UserService } from '../../services/user.service';
import { MessageService } from 'primeng/api';
import { LoaderComponent } from '../loader/loader.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [SharedModule, LoaderComponent],
  providers: [MessageService],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  tenants: tenant[] = [];
  loader: boolean = false;
  submitted: boolean = false;
  isShowTenant: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userservice: UserService,
    private messageService: MessageService
  ) { }

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    tenant: new FormControl({}, Validators.required)
  });

  ngOnInit(): void {
    this.loader = true;
    this.checkIsLogin();
    document.title = 'Mapsoft ERP';
  }

  login(data: any): void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill in all required fields' });
      return;
    }

    let username = data.username;
    this.loader = true;
    const tenant = data.tenant;
    localStorage.setItem("auth", JSON.stringify(data));

    this.authService.login({ Username: data.username, Password: data.password, Tenant: data.tenant }).subscribe({
      next: (data: any) => {
        data.tenant = tenant;
        localStorage.setItem("auth", JSON.stringify(data));
        localStorage.setItem("username", username);
        localStorage.setItem("tenant", tenant);

        this.userservice.getUserMenuTree(data.user.id).subscribe({
          next: menuData => {
            this.loader = false;
            const isDashboardAssigned = menuData
              .some((menu: { subMenu: any[]; }) => menu.subMenu && menu.subMenu.find(subMenu => subMenu.name === 'dashboard'));

            if (isDashboardAssigned) {
              this.router.navigate(['/home/dashboard']);
            } else {
              this.router.navigate(['/home']);
            }

          },
          error: (menuError) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load menu: ' + menuError.message });
            this.loader = false;
          }
        });
      },
      error: (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Credentials' });
        this.loader = false;
      }
    });
  }

  focusNextField(event: KeyboardEvent, nextFieldId: string): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      const nextField = document.getElementById(nextFieldId);
      if (nextField) {
        nextField.focus();
      }
    }
  }

  setTenant(): void {
    if (this.loginForm.controls.tenant.value) {
      const selectedTenant = this.loginForm.controls.tenant.value as tenant;
      localStorage.setItem('TenantId', selectedTenant.code);
    }
  }

  private getTenant() {
    this.userservice.getTenants().subscribe(
      (data: any) => {
        this.tenants = data as tenant[];
        this.loader = false;
      },
      (error: any) => {
        console.error(error);
        this.loader = false;
      }
    );
  }

  private checkIsLogin(): void {
    const authData = localStorage.getItem("auth");
  
    let parsedData: any;
    try {
      parsedData = JSON.parse(authData || '{}');
    } catch (e) {
      this.handleInvalidAuth();
      return;
    }
  
    const userId = parsedData?.user?.id;
  
    if (!userId) {
      this.handleInvalidAuth();
      return;
    }
  
    this.loader = true;
    this.userservice.getUserMenuTree(userId).subscribe({
      next: (menuData: any[]) => {
        this.loader = false;
  
        const isDashboardAssigned = menuData?.some((menu: any) =>
          menu?.subMenu?.some((subMenu: any) => subMenu?.name === 'dashboard')
        );
  
        this.router.navigate([isDashboardAssigned ? '/home/dashboard' : '/home']);
      },
      error: () => {
        this.loader = false;
        this.handleInvalidAuth();
      }
    });
  }
  
  private handleInvalidAuth(): void {
    localStorage.clear();
    if (environment.production) {
      const tenantCode = this.setTenantCode();
      if (tenantCode) {
        this.loginForm.controls.tenant.setValue({ tenantCode: tenantCode, tenantName: '' });
        this.loader = false;
        return;
      }
    }
    this.isShowTenant = true;
    this.getTenant();
  }

  setTenantCode(): string | null {
    const url = window.location.href;
    try {
      const normalizedUrl = url.startsWith("http") ? url : `https://${url}`;
      const { hostname } = new URL(normalizedUrl);

      const parts = hostname.split(".");

      if (parts.length >= 3) {
        return parts[0];
      }
      return null;
    } catch (err) {
      return null;
    }
  }
  

}
